import { loadable } from 'nordic/lazy';

import RenderMultiSelection from './filters/MultiSelectionRenderer';
import ColorFilter from './filters/ColorFilterRenderer';
import SizeFilter from './filters/SizeFilterRenderer';
import FilterLink from './filters/FilterLinkRenderer';

const VehicleBodyItemChunk = loadable(async () =>
  import(
    /* webpackChunkName: "chunk-vehicle-body-item" */ '../../../../vehicle-body-selector/components/vehicle-body-item'
  ),
);

/**
 * Returns the appropriate renderer function based on the provided parameters.
 *
 * @param {Object} options
 * @param {boolean} options.multi_selection
 * @param {string} options.id
 * @param {boolean} [options.image]
 * @returns {React.JSX.ElementType} The renderer function to use.
 */
export const getContentRenderer = ({ multi_selection, id, image }) => {
  if (multi_selection) {
    return RenderMultiSelection;
  }

  switch (id) {
    case 'MAIN_COLOR':
      return ColorFilter;
    case 'SIZE':
    case 'FILTRABLE_SIZE':
      return SizeFilter;
    case 'VEHICLE_BODY_TYPE':
      return image ? VehicleBodyItemChunk : FilterLink;

    default:
      return FilterLink;
  }
};
